export default __webpack_public_path__ + "react/static/orangeStick-7e0b8a0e868561aad63bd886e94b0618.png";